import React, { useState, useEffect, useRef } from 'react';
import '../styles/LazyImage.css';

// Серый квадрат 400x400 в формате SVG как плейсхолдер
const PLACEHOLDER_SRC = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='400'%3E%3Crect width='400' height='400' fill='%23f0f0f0'/%3E%3C/svg%3E";

function LazyImage({ src, alt, className = '', onClick, onImageLoad }) {
  const [imageSrc, setImageSrc] = useState(PLACEHOLDER_SRC);
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Загружаем реальное изображение
            setImageSrc(src);
            observer.disconnect();
          }
        });
      },
      {
        rootMargin: '1000px', // Загружаем сильно заранее для предотвращения скачков
        threshold: 0.01
      }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [src]);

  const handleLoad = () => {
    // Загрузился только если это не плейсхолдер
    if (imageSrc !== PLACEHOLDER_SRC) {
      setIsLoaded(true);
      if (onImageLoad) {
        onImageLoad();
      }
    }
  };

  const handleError = () => {
    if (imageSrc !== PLACEHOLDER_SRC) {
      setHasError(true);
    }
  };

  if (hasError) {
    return (
      <div className="lazy-image-container">
        <div className="lazy-image-error">
          <span>⚠️</span>
          <p>Не удалось загрузить изображение</p>
        </div>
      </div>
    );
  }

  return (
    <img
      ref={imgRef}
      src={imageSrc}
      alt={alt}
      className={`lazy-image ${className} ${isLoaded ? 'loaded' : 'loading'}`}
      onClick={onClick}
      onLoad={handleLoad}
      onError={handleError}
    />
  );
}

export default LazyImage;
